import styled from 'styled-components'

export const Container = styled.div`
  font-family: Roboto, sans-serif; 
`

export const FixedWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: #ffffff;
  height: 170px;
`